import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=1fe5c92a&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5c92a",
  null
  
)

export default component.exports